/**
 * CetusEd Community Portal — Protected Route Guard
 *
 * COMPLIANCE: ⛔ Rule 2 — Fail closed. If auth state cannot be determined
 *   (isLoading is true), render nothing and do not redirect. If the user
 *   is not authenticated, redirect to /login. This ensures no protected
 *   content is rendered before auth state is resolved.
 *
 *   FERPA §1232g(b) — Unauthenticated access to PII is a violation.
 *   This guard is the first line of defense.
 */

import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../auth/AuthProvider';
import { LoadingSpinner } from './components/LoadingSpinner';

export const ProtectedRoute: React.FC = () => {
  const auth = useContext(AuthContext);

  if (!auth || auth.isLoading) {
    return <LoadingSpinner />;
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
